import { makeStyles } from "@mui/styles"
import { Theme } from "@mui/material"

export const UpcomingAppointmentCarouselStyles = makeStyles((theme: Theme) => ({
  appointmentCard: {
    padding: "14px 18px 14px 20px",
    borderRadius: "10px",
    border: "1px solid rgba(112, 112, 112, 0.4)",
    backgroundColor: "rgba(237, 238, 244, 1)",
  },
  appointmentCardContent: {
    paddingLeft: "6px",
    paddingRight: "6px",
  },
  appointmentCardTitle: {
    fontSize: "12px",
    letterSpacing: "0.9px",
    fontWeight: "bold",
    fontFamily: "Inter !important",
    color: "rgba(93, 94, 118, 1) !important",
  },
  appointmentCardValue: {
    fontSize: "12px",
    letterSpacing: "0.9px",
    fontWeight: "bolder",
    fontFamily: "Inter !important",
  },
  appointmentTable: {
    borderCollapse: "collapse",
    backgroundColor: "white",
    border: "1px solid rgba(185, 200, 233, 0.7)",
    borderRadius: "10px",
  },

  cancelButton: {
    border: "1px solid #064CF2 !important",
    color: "black !important",
    textTransform: "capitalize",
    fontFamily: "Inter !important",
  },
  rescheduleButton: {
    backgroundColor: "#064CF2 !important",
    textTransform: "capitalize",
    fontFamily: "Inter !important",
    marginLeft: "10px !important",
  },
  pt14: {
    paddingTop: "14px",
  },
  pt16: {
    paddingTop: "16px",
  },
  titleName: {
    fontSize: "28px",
    letterSpacing: "2.1px",
    fontFamily: "Inter !important",
    fontWeight: "bold",
  },
  noDataState: {
    padding: "8px",
    fontSize: "20px !important",
    letterSpacing: "1.5px !important",
    fontFamily: "Inter !important",
    textTransform: "capitalize",
    minHeight: "38px",
    textAlign: "left",
  },
}))
